module.exports = __webpack_public_path__ + "img/icon_kefu_black-n1.0023f7dd.png";